"use strict";
var DIMENSIONS = {
    storedProcedures: {
        detailsUpdate: {
            entity: ["modify_entries", "insert_entries", "update_entries"],
            service_provider: ["modify_entries", "insert_entries", "update_entries"],
            plan: ["modify_entries", "insert_entries", "update_entries"],
            pricing: ["modify_entries", "insert_entries", "update_entries"],
            task: ["modify_entries", "insert_entries", "update_entries", "last_read_date_update"],
            user: ["modify_entries", "insert_entries", "update_entries"],
            user_entity_role_bridge: ["insert_entries"],
            shareholder: ["modify_entries", "insert_entries", "update_entries"],
            director: ["modify_entries", "insert_entries", "update_entries"],
            member: ["modify_entries", "insert_entries", "update_entries"],
            identity: ["modify_entries", "insert_entries", "update_entries", "get_final_merge_id"],
            identity_identity_bridge: ["insert_entries"],
            document: ["modify_entries", "insert_entries", "update_entries", "last_read_date_update"],
            message: ["modify_entries", "insert_entries", "update_entries"],
            receipt: ["modify_entries", "insert_entries", "update_entries"],
            expense: ["modify_entries", "insert_entries", "update_entries"],
            receipt_expense_entity_bridge: ["insert_entries"],
            invoice: ["modify_entries", "insert_entries", "update_entries"],
            invoice_entity_bridge: ["insert_entries"],
            user_group: ["modify_entries", "insert_entries", "update_entries"],
            user_group_entity_sp_bridge: ["insert_entries"],
            shared: []
        },
        foreignKeysUpdate: {
            entity: ["foreign_key_update"],
            service_provider: [],
            plan: [],
            pricing: [],
            task: ["foreign_key_update"],
            user: ["foreign_key_update"],
            user_entity_role_bridge: ["foreign_key_update"],
            shareholder: ["foreign_key_update"],
            director: ["foreign_key_update"],
            member: [],
            identity: ["foreign_key_update"],
            identity_identity_bridge: ["foreign_key_update"],
            document: ["foreign_key_update"],
            message: ["foreign_key_update"],
            receipt: ["foreign_key_update"],
            expense: ["foreign_key_update"],
            receipt_expense_entity_bridge: ["foreign_key_update"],
            invoice: [],
            invoice_entity_bridge: ["foreign_key_update"],
            user_group: ["foreign_key_update"],
            user_group_entity_sp_bridge: ["foreign_key_update"],
            shared: []
        },
        adhoc: {
            entity: [],
            service_provider: [],
            plan: [],
            pricing: [],
            task: [],
            user: [],
            user_entity_role_bridge: [],
            shareholder: [],
            director: [],
            member: [],
            identity: [],
            identity_identity_bridge: [],
            document: [],
            message: [],
            receipt: [],
            expense: [],
            receipt_expense_entity_bridge: [],
            invoice: [],
            invoice_entity_bridge: [],
            user_group: [],
            user_group_entity_sp_bridge: [],
            shared: ["user_glue_truncate", "receipt_expense_glue_truncate"]
        }
    }
};
var FACTTABLES = {
    storedProcedures: {
        detailsUpdate: {
            entity_lifecycle: ["insert_entries", "update_entries"],
            entity_subscription_change: ["insert_entries"],
            subscription_log: ["insert_entries"],
            share_transaction: ["insert_entries"]
        },
        foreignKeysUpdate: {
            entity_lifecycle: [],
            entity_subscription_change: [],
            subscription_log: ["foreign_key_update"],
            share_transaction: ["foreign_key_update"]
        }
    }
};
var ANALYTICS = {
    storedProcedures: {
        detailsUpdate: {
            entity_derived_attributes: ["insert_entries", "update_entries"],
            entity_subscription_change: ["insert_entries", "update_entries"]
        },
        foreignKeysUpdate: {
            entity_derived_attributes: [],
            entity_subscription_change: []
        }
    }
};
var ETLCONSTANTS = {
    dimensions: DIMENSIONS,
    factTables: FACTTABLES,
    analytics: ANALYTICS
};
module.exports = ETLCONSTANTS;
